import Immutable from 'seamless-immutable';
import dbConsts from './consts';

const CTXS = dbConsts.CONTEXTS;

export const getNewList = () => ({
  items: [],
  metadata: {},
  cursor: 0,
  hasMore: false,
  inProgress: false,
  selected: [],
  lastSelectedIndex: -1,
});

export default () =>
  Immutable({
    __record: 'DropboxRecord',
    lists: {
      [CTXS.FOLDER]: getNewList(),
      [CTXS.RECENT]: getNewList(),
      [CTXS.SEARCH]: getNewList(),
    },
    currentContext: CTXS.FOLDER,
    token: null,
    account: null,
    searchTerm: '',
  });
